import { OnInit, Component, Input, TemplateRef } from "@angular/core";
import { INote } from "./model/INote";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NotesService } from "./services/notes.service";
import { NoteEditModalComponent } from "./note-edit-modal.component";

@Component({
  selector: "notes-list",
  templateUrl: "./notes-list.component.html",
  //styleUrls: ["./notes.component.css"]
})
export class NotesListComponent implements OnInit {

  constructor(private notesService: NotesService, private modalService: BsModalService) {
  }

  loading: boolean;

  @Input() notesList: Array<INote> = [];
  @Input() columns: string[];
  notesViewDetailsModalRef: BsModalRef;

  ngOnInit(): void {
    this.columns = ["Title", "Source", "Updated"];
    this.getNotesListByUser();
  }

  getNotesListByUser() {
    this.notesService.getNotesListByUser().subscribe(result => {
      if (result != null) {
        this.notesList = result;
      }
    });
  }

  openModal(note: INote) {

    let readonly = false;

    if (note != null) {
      readonly = note.step != null;
    }

    const initialState = {
      mode: readonly ? "read" : "add",
      //notesId: note.id,
      readonly: readonly,
      currentNote: note
    };

    this.notesViewDetailsModalRef = this.modalService.show(NoteEditModalComponent, { class: readonly ? "" : "modal-xl", ignoreBackdropClick: true, animated: true, initialState });

    // Subscribe to onClose
    this.notesViewDetailsModalRef.content.onClose.subscribe((success: boolean) => {

      if (success) {
        this.getNotesListByUser();
        this.notesViewDetailsModalRef.hide();
      } else {
        console.log("Error in adding a note");
      }

    });

  }
}
